import { Button, Menu, MenuItem, Stack } from "@mui/material";
import { FC, useState } from "react";
import { AccountCircleOutlined, PortraitOutlined } from "@mui/icons-material";
import { useUIStore } from "@/stores";
import { CreateAdminUser } from "../../modals";
import { AdminRole } from "@/types";

const NewUserButton: FC = () => {
  const { openModal } = useUIStore();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const closeModal = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        size="small"
        color="secondary"
        variant="contained"
        sx={{ minWidth: "auto" }}
        onClick={handleClick}
      >
        New User
      </Button>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        sx={{ marginTop: 1, marginLeft: 1 }}
        onClose={closeModal}
      >
        <MenuItem
          onClick={() => {
            openModal(CreateAdminUser, {
              title: "Add Admin",
              role: AdminRole.ADMIN,
            });
            closeModal();
          }}
        >
          <Stack direction={"row"} gap={1}>
            <AccountCircleOutlined />
            Add Admin
          </Stack>
        </MenuItem>
        <MenuItem
          onClick={() => {
            openModal(CreateAdminUser, {
              title: "Add Vetting Admin",
              role: AdminRole.VETTING_ADMIN,
            });
            closeModal();
          }}
        >
          <Stack direction={"row"} gap={1}>
            <PortraitOutlined /> Add Vetting Admin
          </Stack>
        </MenuItem>
      </Menu>
    </>
  );
};

export { NewUserButton };
